export default "__VITE_ASSET__4fb968c6__"